module.exports = __webpack_public_path__ + "img/scenes_5.bddd3d3d.png";